// Spinner.js
import React from "react";

const spinnerStyle = {
  display: "inline-block",
  width: 40,
  height: 40,
};

const circleStyle = {
  display: "block",
  width: "100%",
  height: "100%",
  border: "6px solid #f3f3f3",
//   borderTop: "6px solid #1976d2",
  borderTop: "6px solid #3e62689c",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
};

const keyframes = `
@keyframes spin {
  0% { transform: rotate(0deg);}
  100% { transform: rotate(360deg);}
}
`;

function Spinner() {
  return (
    <div style={spinnerStyle}>
      <style>{keyframes}</style>
      <span style={circleStyle}></span>
    </div>
  );
}

export default Spinner;
